import TooltipComponent from "../TooltipComponent";

interface SelectProps<T> {
  options: { text: string; value: T }[];
  extraClass?: string;
  onChange: (value: T) => void;
  defaultValue?: T;
  value?: T;
}

const Select = <T extends object>({
  options,
  extraClass,
  onChange,
  defaultValue,
  value
}: SelectProps<T>) => {
  const selectedOption =
    options.find((o) => o.value === value) ??
    options.find((o) => o.value === defaultValue);

  const isSelected = (option: SelectProps<T>["options"][number]) => {
    if (defaultValue === undefined || defaultValue === null) {
      return false;
    }
    return defaultValue === option.value;
  };

  return selectedOption?.text.length > 24 ? (
    <TooltipComponent title={selectedOption?.text}>
      <div style={{ position: "relative" }}>
        <span className="select-text-measure">{selectedOption?.text}</span>
        <select
          className={extraClass}
          onChange={(x) => onChange(options[parseInt(x.target.value)].value)}
          value={value && options.findIndex((x) => x.value === value)}
        >
          {options.map((option, index) => (
            <option
              key={index + option.text}
              value={index}
              selected={isSelected(option)}
            >
              {option.text}
            </option>
          ))}
        </select>
      </div>
    </TooltipComponent>
  ) : (
    <div style={{ position: "relative" }}>
      <span className="select-text-measure">{selectedOption?.text}</span>
      <select
        className={extraClass}
        onChange={(x) => onChange(options[parseInt(x.target.value)].value)}
        value={value && options.findIndex((x) => x.value === value)}
      >
        {options.map((option, index) => (
          <option
            key={index + option.text}
            value={index}
            selected={isSelected(option)}
          >
            {option.text}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
